import {Element} from "@craftjs/core";
import {Action as Button} from "@/src/components/Action";
import {Title} from "@/src/components/Title";
import {List} from "@/src/components/List";
import {Alert} from "@/src/components/Alert";
import {Card} from "@/src/components/Card";
import {Container} from "@/src/components/Container";
import {FlexBox} from "@/src/components/FlexBox";

export function WelcomeCard(props: any) {
    return (
        <Element is={Container} canvas id={"welcome-card"} {...props}>
            <Element is={FlexBox} canvas style={{ flexDirection: "column", gap: 24 }}>
                <Element
                    is={Title}
                    text={
                        "Автозахист - ідеальний варіант захистити автомобіль при ДТП з Вашої вини!"
                    }
                    size={"h2"}
                    background={"#0088ca"}
                />
                <Element
                    is={Card}
                    canvas
                    {...{
                        style: {
                            "box-shadow": "0px 1px 6px 0px rgba(0, 0, 0, 0.12)",
                            gap: "16px",
                            borderRadius: "8px",
                            background: "#FFFFFF",
                            padding: "32px",
                            flexDirection: "column",
                        },
                    }}
                    className={"flex-col md:flex-row"}
                >
                    <Element
                        is={FlexBox}
                        style={{ flexDirection: "column", gap: 24 }}
                        className={"flex-1 order-2 md:order-1"}
                        canvas
                    >
                        <Element
                            is={Title}
                            text={"Умови страхування"}
                            size={"h3"}
                        />
                        <Element
                            is={List}
                            items={[
                                {
                                    value: "Легкові авто віком до 20-ти років",
                                },
                                {
                                    value: "Виплата без вирахування зносу",
                                },
                                {
                                    value: "Вік водіїв від 23 років",
                                },
                                {
                                    value: "Стаж водіїв від 2-х років",
                                },
                                {
                                    value: "Територія дії - Україна",
                                },
                            ]}
                            style={{ gap: "16px" }}
                            listType="custom"
                        />
                        <Element
                            is={FlexBox}
                            style={{
                                gap: 16,
                            }}
                            className={"flex-wrap md:flex-nowrap"}
                            canvas
                        >
                            <Element
                                is={Button}
                                variant={"outlined"}
                                fullWidth
                            >
                                {"Ознайомитись з умовами"}
                            </Element>
                            <Element
                                is={Button}
                                fullWidth
                            >
                                {"Перейти до розрахунку"}
                            </Element>
                        </Element>
                    </Element>
                    <Element
                        is={FlexBox}
                        style={{ height: "100%", width: "100%", alignItems: "center", justifyContent: "center" }}
                        className={"flex-1 order-1 md:order-2"}
                        canvas
                    >
                        <Element is={Image} />
                    </Element>
                </Element>
                <Element
                    is={Alert}
                    title={
                        "При укладанні договору для авто з пробігом більше 1 000 км та/або віком авто понад 2 роки обов'язково  потрібно проводити огляд авто. Для цього необхідно перейти до розрахунку, заповнити усі необхідні дані і менеджер зв'яжеться з вами для проведення огляду авто, підписання і оплати договору."
                    }
                    description={""}
                />
            </Element>
        </Element>
    );
}
